import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  CAL_PARTNERS_BOOKING_URL,
  DISCORD_URL,
  EMAIL_SALES,
} from '@app/config';
import { TuiButton } from '@taiga-ui/core';

@Component({
  selector: 'app-partners-cta-section',
  imports: [RouterLink, TuiButton],
  templateUrl: './partners-cta-section.component.html',
  styleUrl: './partners-cta-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersCtaSectionComponent {
  protected readonly emailSales = EMAIL_SALES;
  protected readonly bookingUrl = CAL_PARTNERS_BOOKING_URL;
  protected readonly discordUrl = DISCORD_URL;
}
